// module for holding config settings

const host = (window.location.host && window.location.host.toUpperCase()) || "";
export const isLocal = host.toUpperCase().indexOf("LOCALHOST") > -1;
const isDEV = host.toUpperCase().indexOf("VFGWGE24DEV") > -1;
const isPROD = host.toUpperCase().indexOf("BIHUB") > -1;
const isUAT = host.toUpperCase().indexOf("BIHUBTEST") > -1;

export const URLS = {
  API: `/api/bihub/`,
  LOCAL: "https://localhost:44310",
  DEV: "http://VFGWGE24DEV.atf.local:2023",
  PROD: "https://bihub.evansdelivery.com",
  UAT: "https://bihubtest.evansdelivery.com",
};

export const baseURL =
  (isLocal && URLS.LOCAL) ||
  (isDEV && URLS.DEV) ||
  (isUAT && URLS.UAT) ||
  (isPROD && URLS.PROD);

const backendHost = new URL(baseURL || window.location.origin).host
  .toUpperCase()
  .replace(":", "_");
export const accessTokenName = `${backendHost}_PPAccessToken`;
export const refreshTokenName = `${host}_PPRefreshToken`;

export const KEYS = {};
export const apiURL = `${baseURL}${URLS.API}`;

// True on localhost and dev server drives the TEST badge in the layout
export const isTestSite = isLocal || isDEV || isUAT;
